import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export interface StickerProps extends UniclientBaseComponentProps {
  readonly src: string;
  readonly alt: string;
  readonly width?: number;
  readonly height?: number;
}

export type UniclientStickerProps = StickerProps & UniclientWizardComponentBase<'sticker'>;

export function sticker(props: StickerProps): UniclientStickerProps {
  return { ...props, type: 'sticker' };
}
